import { render, staticRenderFns } from "./fullpage_hint.vue?vue&type=template&id=001803e0&"
import script from "./fullpage_hint.vue?vue&type=script&lang=js&"
export * from "./fullpage_hint.vue?vue&type=script&lang=js&"
import style0 from "./fullpage_hint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('001803e0', component.options)
    } else {
      api.reload('001803e0', component.options)
    }
    module.hot.accept("./fullpage_hint.vue?vue&type=template&id=001803e0&", function () {
      api.rerender('001803e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/notification/fullpage_hint.vue"
export default component.exports